import React from 'react';

import type { IconComponentFunction } from '@motorway/mw-highway-code';
import { Icon } from '@motorway/mw-highway-code';

import { ReactComponent as IconComponent } from '../../../../client/assets_seller/serviceFees/agent.svg';

export const AgentIcon: IconComponentFunction = (props) => (
  <Icon {...props}>
    <IconComponent />
  </Icon>
);
